/**
 * Cross-tree "the copilot just changed CRM data" signal — the generic
 * counterpart to `taskEvents`/`meetingEvents`/`leadEvents`/`projectEvents`.
 * Grok commits writes from its own React tree (voice provider / chat panel),
 * so a task it completes or a meeting it books wouldn't repaint the Home
 * dashboard the user is literally watching until the 30s stale window
 * expired. Any dashboard that shows live work (Home first) subscribes and
 * refetches the instant the copilot commits something.
 */
const EVENT = 'nk:crm-data-changed';

/** Fire after ANY copilot write commits (tool write, tapped Confirm, plan
 *  run, CRM send) — subscribed dashboards refetch immediately. */
export function emitCrmDataChanged(): void {
    try { window.dispatchEvent(new CustomEvent(EVENT)); } catch { /* non-browser */ }
}

/** Subscribe to copilot data changes. Returns an unsubscribe fn. */
export function onCrmDataChanged(handler: () => void): () => void {
    if (typeof window === 'undefined') return () => {};
    window.addEventListener(EVENT, handler);
    return () => window.removeEventListener(EVENT, handler);
}
